window.addEventListener("load", function () {

  const btnMusic = document.querySelector('.btn-music');
  const content = document.querySelector('#Frame1 .content[data-audio]');

  if (!btnMusic || !content) return;

  const audio = new Audio(content.dataset.audio);
  audio.loop = true;
  let started = false;

  function play() {
    audio.play().catch(() => {});
    btnMusic.classList.remove('mute');
    started = true;
  }

  function onFirstInteraction() {
    play();
    document.removeEventListener('click', onFirstInteraction);
  }

  document.addEventListener('click', onFirstInteraction);

  btnMusic.addEventListener('click', function (e) {
    e.preventDefault();
    // Lần đầu click btn-music: để onFirstInteraction (document) xử lý play
    if (!started) return;

    if (audio.paused) {
      play();
    } else {
      audio.pause();
      btnMusic.classList.add('mute');
    }
  });
});
